import { useEffect, useState } from 'react'
import styled from 'styled-components'
import { DB } from '../firebase'
import { useAuthContext } from './contexts/AuthContext'
import ZoomingAnimation from './partials/ZoomingAnimation'
import { tsToDate } from './utils/tsToDate'

function Announcements() {
    const { userDetails } = useAuthContext()

    const [announcement, setAnnouncement] = useState([])
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        const announcementListner =
            !!userDetails &&
            DB.collection('announcements')
                .where(
                    'batchArray',
                    'array-contains',
                    userDetails?.batch?.batchName
                )
                .orderBy('time', 'desc')
                .onSnapshot((querySnapshot) => {
                    var arr = []
                    querySnapshot.forEach((doc) => {
                        arr.push({
                            id: doc.id,
                            ...doc.data()
                        })
                    })
                    setAnnouncement(arr)
                    setLoading(false)
                })

        return () => announcementListner
    }, [])

    return (
        <AnnouncementContainer>
            <Heading>Announcements</Heading>

            {!!announcement.length &&
                announcement.map((item, key) => (
                    <AnnouncementCard key={key}>
                        <Title>{item?.title}</Title>
                        <Description>{item?.description}</Description>
                        {!!item?.time && (
                            <DateOfAnnounce>{`${tsToDate(item?.time)[1]} , ${
                                tsToDate(item?.time)[2]
                            }`}</DateOfAnnounce>
                        )}
                    </AnnouncementCard>
                ))}

            {!!!announcement.length && loading && <ZoomingAnimation />}

            {!!!announcement.length && !loading && (
                <NotAvailable>No Announcements Available</NotAvailable>
            )}
        </AnnouncementContainer>
    )
}

const AnnouncementContainer = styled.div`
    padding-top: 4.8rem;
    margin-bottom: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
`

const Heading = styled.h1`
    text-align: center;
    color: #fff;
    padding: 1.2rem 0;
    font-size: 24px;
    z-index: 1;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    background-color: #2e2e53;
`

const AnnouncementCard = styled.div`
    margin: 20px auto;
    padding: 20px;
    background: linear-gradient(
            112.42deg,
            #2e2e53 8.39%,
            #2e2e53 55.23%,
            #2e2e53 85.97%
        ),
        #292948;
    border: 2px solid #363862;
    width: 100%;
    max-width: 500px;
    box-sizing: border-box;
    box-shadow: 9px 9px 16px rgba(30, 34, 50, 0.6);
    border-radius: 8px;
`

const Title = styled.h1`
    text-align: center;
    color: #dee3ff;
    font-weight: 700;
    padding-bottom: 15px;
    border-bottom: 1px solid #363862;
    font-size: 16px;
`

const Description = styled.p`
    font-weight: 500;
    color: #dee3ff;
    text-align: left;
    font-size: 14px;
    padding: 20px 0;
`

const DateOfAnnounce = styled.p`
    font-weight: 500;
    color: #8e95bc;
    text-align: right;
    font-size: 14px;
`

const NotAvailable = styled.p`
    text-align: center;
    color: #fff;
    margin: 30px 0;
`

export default Announcements
